// import { RequestError } from './errors';
import isPromise from 'redux-promise-middleware/dist/isPromise';

import { REQUEST_FAIL, REQUEST_TYPE_SUFFIXES as defaultTypes, PROMISE_TYPE_DELIMITER as defaultDelimiter, createRequestTypes } from '../../actions/actionTypes';



function apiMiddleware (config = {}) {
  const REQUEST_TYPE_SUFFIXES = config.requestTypeSuffixes || defaultTypes;
  const PROMISE_TYPE_DELIMITER = config.promiseTypeDelimiter || defaultDelimiter;
  const [START, SUCCESS, FAIL] = REQUEST_TYPE_SUFFIXES;
  
  const startSuffix = REQUEST_TYPE_SUFFIXES[0];
  const startTypeRegExp = new RegExp(`${PROMISE_TYPE_DELIMITER}${startSuffix}$`, 'i')
  const replaceTypesRegExp = new RegExp(`${PROMISE_TYPE_DELIMITER}(${REQUEST_TYPE_SUFFIXES.join('|')})$`, 'i')
  
  const baseType = (type) =>
    typeof type === "object" ? type.__BASE : type.replace(replaceTypesRegExp, '')
  
  
  return ({ getState, dispatch }) => {
    return next => action => {
      const { payload, data } = action;
      
      if (!payload || !isPromise(payload))
        return next(action)
      
      if ( typeof action.type === "object" && !action.type[startSuffix] ) 
        return next(action)
      
      if ( typeof action.type === "string" && !action.type.match(startTypeRegExp) )
        return next(action)
      
      const actionTypes = ( typeof action.type === "string") ? createRequestTypes(baseType(action.type)) : action.type
      
      const handleSuccess = (res) => {
        next({
          ...action,
          type: actionTypes[SUCCESS],
          payload: res
        });
      }
      
      const handleFailure = (res) => {
        next({
          ...action,
          type: actionTypes[FAIL],
          payload: res,
          error: true
        });
        
        if (res.statusCode !== 422)
          next({
            ...action,
            type: REQUEST_FAIL,
            payload: res,
            error: true
          });
        
      }
      
      next({
        ...action,
        type: actionTypes[START],
        payload: data // NOT PROMISE (to prevent double promiseMiddleware call)
      })
      
      return payload.then(handleSuccess, handleFailure)
    }
  }
}
  
  // return next => action => {
  //   // Do not process actions without an [RSAA] property
  //   if (!isApi(action)) {
  //     return next(action);
  //   }
  //   
  //   return (async () => {
  //     
  //     // Parse the validated RSAA action
  //     const callAPI = action[RSAA];
  //     var { endpoint, body, headers, options = {} } = callAPI;
  //     const { method, credentials, bailout, types } = callAPI;
  //     const [requestType, successType, failureType] = normalizeTypeDescriptors(
  //       types
  //     );
  // 
  //     // Should we bail out?
  //     try {
  //       if (
  //         (typeof bailout === 'boolean' && bailout) ||
  //         (typeof bailout === 'function' && bailout(getState()))
  //       ) {
  //         return;
  //       }
  //     } catch (e) {
  //       return next(
  //         await actionWith(
  //           {
  //             ...requestType,
  //             payload: new RequestError('[RSAA].bailout function failed'),
  //             error: true
  //           },
  //           [action, getState()]
  //         )
  //       );
  //     }
  // 
  //     // Process [RSAA].endpoint function
  //     if (typeof endpoint === 'function') {
  //       try {
  //         endpoint = endpoint(getState());
  //       } catch (e) {
  //         return next(
  //           await actionWith(
  //             {
  //               ...requestType,
  //               payload: new RequestError('[RSAA].endpoint function failed'),
  //               error: true
  //             },
  //             [action, getState()]
  //           )
  //         );
  //       }
  //     }
  // 
  //     // Process [RSAA].body function
  //     if (typeof body === 'function') {
  //       try {
  //         body = body(getState());
  //       } catch (e) {
  //         return next(
  //           await actionWith(
  //             {
  //               ...requestType,
  //               payload: new RequestError('[RSAA].body function failed'),
  //               error: true
  //             },
  //             [action, getState()]
  //           )
  //         );
  //       }
  //     }
  // 
  //     // Process [RSAA].headers function
  //     if (typeof headers === 'function') {
  //       try {
  //         headers = headers(getState());
  //       } catch (e) {
  //         return next(
  //           await actionWith(
  //             {
  //               ...requestType,
  //               payload: new RequestError('[RSAA].headers function failed'),
  //               error: true
  //             },
  //             [action, getState()]
  //           )
  //         );
  //       }
  //     }
  // 
  //     // Process [RSAA].options function
  //     if (typeof options === 'function') {
  //       try {
  //         options = options(getState());
  //       } catch (e) {
  //         return next(
  //           await actionWith(
  //             {
  //               ...requestType,
  //               payload: new RequestError('[RSAA].options function failed'),
  //               error: true
  //             },
  //             [action, getState()]
  //           )
  //         );
  //       }
  //     }
  // 
  //     // We can now dispatch the request FSA
  //     if (
  //       typeof requestType.payload === 'function' ||
  //       typeof requestType.meta === 'function'
  //     ) {
  //       next(await actionWith(requestType, [action, getState()]));
  //     } else {
  //       next(requestType);
  //     }
  // 
  //     try {
  //       // Make the API call
  //       var res = await fetch(endpoint, {
  //         ...options,
  //         method,
  //         body: body || undefined,
  //         credentials,
  //         headers: headers || {}
  //       });
  //     } catch (e) {
  //       // The request was malformed, or there was a network error
  //       return next(
  //         await actionWith(
  //           {
  //             ...requestType,
  //             payload: new RequestError(e.message),
  //             error: true
  //           },
  //           [action, getState()]
  //         )
  //       );
  //     }
  // 
  //     // Process the server response
  //     if (res.ok) {
  //       return next(await actionWith(successType, [action, getState(), res]));
  //     } else {
  //       return next(
  //         await actionWith(
  //           {
  //             ...failureType,
  //             error: true
  //           },
  //           [action, getState(), res]
  //         )
  //       );
  //     }
  //   })();
  // };
//}

export { apiMiddleware };


// WEBPACK FOOTER //
// ./src/middleware/api/index.js